import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Manage from '../components/Manage'
import Fashion from '../components/Fashion'
import Login from '../components/Login'
import Register from '../components/Register'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/manage',
            name: 'Manage',
            component: Manage
        },
        {
            path: '/fashion',
            name: 'Fashion',
            component: Fashion
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        }
    ]
})